export const URL_RE = /^https?:\/\/.+/i;
export const LOG_COLORS = { log: "text-gray-700", warn: "text-yellow-600", error: "text-red-600", alert: "text-orange-600", info: "text-blue-600" };

export function toRows(result) {
    if (!result) return null;
    const data = result?.output || result?.result || result;
    if (Array.isArray(data)) {
        if (data.length === 0) return null;
        if (typeof data[0] === "object" && data[0] !== null) return data;
        return data.map((v) => ({ value: v }));
    }
    if (typeof data === "object" && data !== null) return [data];
    return [{ value: data }];
}

export function extractColumns(rows) {
    const colSet = new Set();
    for (let i = 0; i < Math.min(rows.length, 50); i++) Object.keys(rows[i]).forEach((k) => colSet.add(k));
    return Array.from(colSet);
}

export function formatCell(val) {
    if (val == null) return "";
    return typeof val === "object" ? JSON.stringify(val, null, 2) : String(val);
}

export function formatLogArg(arg) {
    if (arg == null) return "";
    if (typeof arg === "string") return arg;
    return JSON.stringify(arg, null, 2);
}
